export const YOUR_SERVICE_ID='service_gwmxg9p';
export const YOUR_TEMPLATE_ID='template_sbmi0ei';
export const YOUR_PUBLIC_KEY='IOMdjMgQjWDQUl-cW';
